import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";


import { getClassNames } from "../../../Js/Common";
import LearnerList from './LearnerList';
import LearnerDetail from './LearnerDetail';
import { Grid } from '@mui/material';


const LearnersReport = () => {

    // Hooks
    // const classes = useStyles();

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

    //State
    const [allClasses, setAllClasses] = useState([]);
    const [alertFlag, setAlertFlag] = useState(false);
    const [isLearnerList, setIsLearnerList] = useState(true);

    const [reportData, setReportData] = useState([]);
    const [startOfDate, setStartOfDate] = useState(null);
    const [endOfMonth, setEndOfMonth] = useState(null);

    const [selectedClass, setSelectedClass] = useState(null);
    const [selectedClassId, setSelectedClassId] = useState(null);

    // React logic hooks
    useEffect(() => {
        const initialRender = async () => {
            let classesData = await getClassNames(userInfo.site_uuid);
            if (classesData.length === 0) {
                return;
            }
            setAllClasses(classesData);
            return;
        }
        initialRender();
    }, []);

    // Set class list
    const filterClass = (classId) => {
        let findObj = allClasses.find((obj) => {
            return obj.id == classId
        });
        return findObj.value || '';
    };

    const goToLearnerDetail = async (reportData, startOfDate, endOfMonth, selectedClass) => {
        console.log("selectedClassId",selectedClassId);
        setReportData(reportData);
        setStartOfDate(startOfDate);
        setEndOfMonth(endOfMonth);
        let className = filterClass(selectedClass);
        setSelectedClass(className);

        let obj = {
            'id': selectedClass,
            'value': className
        }
        setSelectedClassId(obj);

        if (reportData.total_active_assignments == null) {
            setAlertFlag(true);
        } else {
            setIsLearnerList(false);
            setAlertFlag(false);
        }
    }

    return (
        <Grid container>
            <Grid xs={12}>
                {isLearnerList &&
                    <LearnerList
                        allClasses={allClasses}
                        goToLearnerDetail={goToLearnerDetail}
                        alertFlag={alertFlag}
                        handleAlertFlag={(flg) => { setAlertFlag(flg) }}
                    />
                }
                {!isLearnerList &&
                    <LearnerDetail
                        reportData={reportData}
                        selectedClass={selectedClass}
                        startOfDate={startOfDate}
                        endOfMonth={endOfMonth}
                        selectedClassId={selectedClassId}
                        backList={(bakVal) => { setIsLearnerList(bakVal) }}
                    />
                }
            </Grid>
        </Grid>

    );
}

// const useStyles = makeStyles({
// });

export default LearnersReport;